import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const HIDE_AFTER = 48;
const SHOW_AFTER = 24;

// Resets on navigation so a new page never opens with the bar already hidden.
// `gateId`: no hiding until that element hits the top; showing is never gated.
export default function useHideOnScroll(gateId?: string): boolean {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(true);
    let last = window.scrollY;

    const gateReached = () => {
      if (!gateId) return true;
      const el = document.getElementById(gateId);
      if (!el) return true;
      return el.getBoundingClientRect().top <= 0;
    };

    // `last` moves only on a crossing, so small scrolls accumulate toward one.
    const onScroll = () => {
      const y = window.scrollY;
      if (y < 80) {
        setVisible(true);
        last = y;
      } else if (y > last + HIDE_AFTER) {
        setVisible(!gateReached());
        last = y;
      } else if (y < last - SHOW_AFTER) {
        setVisible(true);
        last = y;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [pathname, gateId]);

  return visible;
}
